export default {
  namespaced: true,
  state: {
    timeHistory: '', //记录当前加载的时间点
    cityName: '中国',
    Maplevel: 0,
    dataType: 3, // 记录当前选中得数据类型
    timeId: undefined, // 记录用户选择年份
    lowerLevelData: {},
    glanceType: undefined, // 数据概览选中类型
    mapIconTotle: [], //地图聚合撒点
    screenMaplevel: 0, //全流程溯源大屏地图层级
    currentlyMapAdcode:undefined, // 记录当前地图的adcode
    companyId:''
  },
  mutations: {
    changeCurrentlyMapAdcode(state, data) {
      state.currentlyMapAdcode = data;
    },
    changeMapIconTotle(state, data) {
      state.mapIconTotle = data;
    },
    changeDataType(state, data) {
      state.dataType = data;
    },
    changeLowerLevelData(state, data) {
      state.lowerLevelData = data;
    },
    changeGlanceType(state, data) {
      state.glanceType = data;
    },
    changeTimeRange(state, data) {
      state.timeId = data;
    },
    changeCompanyId(state, data) {
      state.companyId = data;
    },
    changeMapLevel(state, data) {
      state.Maplevel = data;
    },
    SET_MAP_LEVEL(state, data) {
      state.screenMaplevel = data;
    },
  },
  action: {},
  getter: {},
};
